import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// ⚠️ PRODUCTION DATABASE - AIEC TestDB (Main Database with all registrations)
const firebaseConfig = {
  apiKey: "AIzaSyAApqbeJh5hiuRGVWEauNC-pz3sHjDUz7s",
  authDomain: "aiec-testdb.firebaseapp.com",
  projectId: "aiec-testdb",
  storageBucket: "aiec-testdb.firebasestorage.app",
  messagingSenderId: "563429998745",
  appId: "1:563429998745:web:8a3d8f1ba0242b52b9b808",
  measurementId: "G-MNQJJMS9ZF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app;